import { fromUrl, parseDomain, ParseResultType } from 'parse-domain';
const LOCALHOST = 'localhost';
const HTTP = 'http://';
const HTTPS = 'https://';
export class CrossOriginValidator {
    constructor(allowedOrigins) {
        this.allowedOrigins = [];
        this.isLocalhost = (requestOrigin, parsedOrigin) => {
            if (parsedOrigin.type === ParseResultType.Reserved) {
                if (parsedOrigin.hostname === LOCALHOST) {
                    if (parsedOrigin.hostname === requestOrigin.hostname) {
                        return true;
                    }
                }
            }
            return false;
        };
        this.isHttp = (origin) => origin.indexOf(HTTP) > -1;
        this.allowedOrigins = allowedOrigins.map((allowedOrigin) => {
            if (allowedOrigin.indexOf(HTTP) > -1 ||
                allowedOrigin.indexOf(HTTPS) > -1 ||
                allowedOrigin.indexOf(LOCALHOST) > -1) {
                return parseDomain(fromUrl(allowedOrigin));
            }
            return parseDomain(allowedOrigin);
        });
    }
    sameArray(arrOne, arrayTwo) {
        return (arrOne.length === arrayTwo.length &&
            arrOne.every((element, index) => element === arrayTwo[index]));
    }
    isValidDomain(requestOrigin, parsedOrigin) {
        const domainMatch = parsedOrigin.domain === requestOrigin.domain;
        const tolLevelDomainMatch = this.sameArray(parsedOrigin.topLevelDomains, requestOrigin.topLevelDomains);
        return domainMatch && tolLevelDomainMatch;
    }
    isValid(origin) {
        const requestOrigin = parseDomain(fromUrl(origin));
        return this.allowedOrigins.some((allowedOrigin) => {
            if (this.isLocalhost(requestOrigin, allowedOrigin)) {
                return true;
            }
            if (allowedOrigin.type !== ParseResultType.Reserved) {
                if (this.isHttp(origin)) {
                    return false;
                }
                return this.isValidDomain(requestOrigin, allowedOrigin);
            }
            return false;
        });
    }
}
//# sourceMappingURL=CrossOriginValidator.js.map